// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"138":"38a8be7c069a3a6ed0c3","427":"38a8be7c069a3a6ed0c3"}[chunkId] + ".css";
};